// extracted by mini-css-extract-plugin
module.exports = {"collectionDot":"collectionDot_collectionDot__NlVZc"};